import React, { useContext } from "react";
import { useEffect, useState } from "react";
import REF from "./adminRef.module.scss";
import OPPCss from "../../../../Dashboard/Opportunities/Opportunities.module.scss";
import Sidebar from "../../../Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";
import notAvail from "../../../../../assets/notAvail.png";
import "../../../../Dashboard/Portfolio/myPortfolio.scss";
import { toast } from "react-toastify";

function AdminRef() {
  const navigate = useNavigate();
  const location = useLocation();
  const refData = location?.state?.data;

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };
  const [refferalToggle, setRefferalToggle] = useState(true);

  const toggleView = () => {
    const newPosition = !refferalToggle ? "admin" : "user";
    setRefferalToggle(!refferalToggle);
    localStorage.setItem("ReferralTogglePosition", newPosition);
  };

  const [portfolioList, setPortfolioList] = useState([]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(true);

  // function to fetch all ref admin details
  const [refAdminDetail, setRefAdminDetail] = useState([]);
  const fetchAdminRefDetail = async () => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/CP/get_partner_referred_admin_details?user_id=${refData.partner_id}`;

    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (data.referral_details[0] === "No Referrals to show") {
        setLoading(false);
        setNoData(true);
        toast.error(data.referral_details[0]);
        setRefAdminDetail(data);
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/adminlogin");
        window.location.reload();
        setLoading(false);
      } else {
        setRefAdminDetail(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAdminRefDetail();
    const storedPosition = localStorage.getItem("ReferralTogglePosition");
    if (storedPosition === "user") {
      setRefferalToggle(false);
    }
  }, []);
  const getBaseUrl = () => {
    if (process.env.NODE_ENV === "development") {
      return process.env.REACT_APP_LOCAL_URL;
    } else if (window.location.hostname === "www.ballerslife.co") {
      return process.env.REACT_APP_PRODUCTION_URL;
    } else if (
      window.location.hostname === "dashboard.d12986ti7njhej.amplifyapp.com"
    ) {
      return process.env.REACT_APP_DASHBOARD_URL;
    }
    return "";
  };
  const [copiedReferralCodes, setCopiedReferralCodes] = useState(false);
  const handleCopy = () => {
    const baseUrl = getBaseUrl();
    console.log(process.env.REACT_APP_LOCAL_URL, "URL");
    const urlWithCode = `${baseUrl}?referralCode=${refAdminDetail.referral_code}`;
    navigator.clipboard
      .writeText(urlWithCode)
      .then(() => {
        setCopiedReferralCodes(true);
        setTimeout(() => {
          setCopiedReferralCodes(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const year = date.getFullYear();
    // return `${day}/${month}/${year}`;
    return `${day}-${month}-${year}`;
  };
  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num?.toString();
    }
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }

    return formattedNumber;
  };

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        {loading ? (
          <Loader />
        ) : (
          <>
            {portfolioList === null ? (
              <>
                <div className="portMainicon">
                  <div className="portfolioImg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="64"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#FFB000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-shield-off"
                      style={{ marginBottom: "1rem" }}
                    >
                      <path d="m2 2 20 20" />
                      <path d="M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71" />
                      <path d="M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264" />
                    </svg>
                  </div>
                  <p className="portNotfound">
                    Access Denied: You do not have sufficient permissions to
                    view this page.
                  </p>
                </div>
              </>
            ) : (
              <>
                <div style={{ marginTop: hideSvg ? "58px" : "0" }}>
                  <>
                    <div className={REF.goBackSvg}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#FFBF00"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-chevron-left"
                        cursor="pointer"
                        onClick={() => {
                          navigate("/admin/referral");
                        }}
                      >
                        <path d="m15 18-6-6 6-6" />
                      </svg>
                    </div>
                    <div className={REF.headerMainAdmin}>
                      {/* top comp */}
                      <div className={REF.headerTop}>
                        <div className={REF.headerTopCont}>
                          <p>NAME</p>
                          <p>PHONE NO</p>
                          <p>REFERRALS</p>
                          <p>COMMISSION</p>
                          <p>SHARE LINK</p>
                        </div>
                        <div className={REF.headerTopContSec}>
                          <p>{refAdminDetail.name}</p>
                          <p>
                            {refAdminDetail.country_code}{" "}
                            {refAdminDetail.phone_no}
                          </p>
                          <p>{refAdminDetail.total_referrals}</p>
                          <p>
                            $ {formatNumber(refAdminDetail.total_commission)}
                          </p>
                          <div className={REF.refCode}>
                            <p>{refAdminDetail.referral_code}</p>
                            <p onClick={handleCopy}>
                              {copiedReferralCodes ? <>Copied </> : <>Copy</>}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Card for header */}
                      <div className=" portOverviewCard">
                        <div className={REF.invDetailMain}>
                          <div className={REF.invContDop}>
                            <p className={OPPCss.investmentHeaderPortDop}>
                              Name :
                            </p>
                            <p className={OPPCss.invContSec}>
                              {refAdminDetail.name}
                            </p>
                          </div>
                          <div className={REF.invContDop}>
                            <p className={OPPCss.investmentHeaderPortDop}>
                              Phone No :
                            </p>
                            <p className={OPPCss.invContSec}>
                              {refAdminDetail.country_code}{" "}
                              {refAdminDetail.phone_no}
                            </p>
                          </div>
                          <div className={REF.invContDop}>
                            <p className={OPPCss.investmentHeaderPortDop}>
                              Referral :
                            </p>
                            <p className={OPPCss.invContSec}>
                              {refAdminDetail.total_referrals}
                            </p>
                          </div>
                          <div className={REF.invContDop}>
                            <p className={OPPCss.investmentHeaderPortDop}>
                              Commission :
                            </p>
                            <p className={REF.invContSec}>
                              $ {formatNumber(refAdminDetail.total_commission)}
                            </p>
                          </div>
                          <div className={REF.invContDop}>
                            <p className={OPPCss.investmentHeaderPortDop}>
                              Share Link :
                            </p>
                            <p className={OPPCss.invContSec}>
                              <div className={REF.refCode}>
                                <p>{refAdminDetail.referral_code}</p>
                                <p onClick={handleCopy}>
                                  {copiedReferralCodes ? (
                                    <>Copied </>
                                  ) : (
                                    <>Copy</>
                                  )}
                                </p>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* details */}
                      {noData ? (
                        <div className="portMainicon">
                          <div className="portfolioImg">
                            <img src={notAvail} alt="" />
                          </div>
                          <p className="portNotfound">No referral to show</p>
                        </div>
                      ) : (
                        <div className={REF.headerMain}>
                          <div className={REF.headerSec}>
                            <p>Name</p>
                            <p>Apply Date</p>
                            <p>Status</p>
                            <p>Invested Amount</p>
                            <p>Commission</p>
                          </div>
                          <div className={REF.detailMain}>
                            {refAdminDetail.referral_details.map(
                              (data, index) => (
                                <>
                                  <div className={REF.detailSec}>
                                    <p className={REF.detailCont}>
                                      {data.user_details.user_name}
                                    </p>
                                    <p className={REF.detailCont}>
                                      {/* {data.user_details.application_date} */}
                                      {formatDate(
                                        data.user_details.application_date
                                      )}
                                    </p>
                                    <p className={REF.detailCont}>
                                      {data.user_details.status}
                                    </p>
                                    <p className={REF.detailCont}>
                                      ${" "}
                                      {formatNumber(
                                        data.user_details.invested_amount
                                      )}
                                    </p>
                                    <p className={REF.detailCont}>
                                      ${" "}
                                      {formatNumber(
                                        data.user_details.commission
                                      )}
                                    </p>
                                  </div>
                                  {/* Card for res */}
                                  <div className={REF.cardMain}>
                                    <div>
                                      <div className={OPPCss.invCont}>
                                        <p
                                          className={
                                            OPPCss.investmentHeaderPort
                                          }
                                        >
                                          Name :
                                        </p>
                                        <p className={OPPCss.invContSec}>
                                          {data.user_details.user_name}
                                        </p>
                                      </div>
                                      <div className={OPPCss.invCont}>
                                        <p
                                          className={
                                            OPPCss.investmentHeaderPort
                                          }
                                        >
                                          Apply Date :
                                        </p>
                                        <p className={OPPCss.invContSec}>
                                          {data.user_details.application_date}
                                        </p>
                                      </div>

                                      <div className={OPPCss.invCont}>
                                        <p
                                          className={
                                            OPPCss.investmentHeaderPort
                                          }
                                        >
                                          Status :
                                        </p>
                                        <p className={OPPCss.invContSec}>
                                          {data.user_details.status}
                                        </p>
                                      </div>
                                      <div className={OPPCss.invCont}>
                                        <p
                                          className={
                                            OPPCss.investmentHeaderPort
                                          }
                                        >
                                          Invested Amount :
                                        </p>
                                        <p className={OPPCss.invContSec}>
                                          ${" "}
                                          {formatNumber(
                                            data.user_details.invested_amount
                                          )}
                                        </p>
                                      </div>
                                      <div className={OPPCss.invCont}>
                                        <p
                                          className={
                                            OPPCss.investmentHeaderPort
                                          }
                                        >
                                          Commission :
                                        </p>
                                        <p className={OPPCss.invContSec}>
                                          ${" "}
                                          {formatNumber(
                                            data.user_details.commission
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default AdminRef;
